import axios from "axios";
import { baseUrl, headers } from "../config/env";

export function logout() {
  return axios.delete(baseUrl + "/api/logout", { headers });
}

// 유저
export function createUser(data) {
  return axios.post(baseUrl + "/accounts/join", data, { headers });
}
export function login(data) {
  return axios.post(baseUrl + "/accounts/login", data, { headers });
}
export function fetchProfile() {
  return axios.get(baseUrl + `/accounts/profile`, { headers });
}
export function findEmail(data) {
  return axios.post(baseUrl + `/accounts/find/accountId`, data, { headers });
}
export function updateProfile(data) {
  return axios.put(baseUrl + `/accounts/profile`, data, { headers });
}
export function deleteProfile(data) {
  return axios.post(baseUrl + `/accounts/withdraw`, data, { headers });
}
export function createCertNumber(data) {
  return axios.post(baseUrl + `/auth/sms/cert`, data, { headers });
}
export function verifyMobile(data) {
  return axios.post(baseUrl + `/auth/sms/verify`, data, { headers });
}
export function findAccountPw(data) {
  return axios.post(baseUrl + `/accounts/resetPwd`, data, { headers });
}
export function updatePassword(data) {
  return axios.put(baseUrl + `/accounts/pwd`, data, { headers });
}
export function updateUserPwd(data) {
  return axios.put(baseUrl + `/accounts/changePwd`, data, { headers });
}

// 알람
export function fetchAlarm(params) {
  return axios.get(baseUrl + `/alarm`, { params, headers });
}
export function fetchAlarmList(params) {
  return axios.get(baseUrl + `/alarm/list`, { params, headers });
}
